 /* var imgelem1A = function(){document.getElementById('imgstepbig1-hid').id = "imgstepbig1";};
  var imgelem1H = function(){document.getElementById('imgstep1-hid').id = "imgstep1";};
  var imgN1  = function(){document.getElementById('imgstep1-hid').style.display = "none";};
  var imgNB1 = function(){document.getElementById('imgstepbig1-hid').style.display = "none";};
  var imgelem2A = function(){document.getElementById('imgstepbig2-hid').id = "imgstepbig2";};
  var imgelem2H = function(){document.getElementById('imgstep2').id = "imgstep2-hid";};
  var imgN2 = function(){document.getElementById('imgstep2').style.display = "none";};
  var imgelem3A = function(){document.getElementById('imgstepbig3-hid').id = "imgstepbig3";};
  var imgelem3H = function(){document.getElementById('imgstep3').id = "imgstep3-hid";};
  var imgN3 = function(){document.getElementById('imgstep3').style.display = "none";};
  var imgelem4A = function(){document.getElementById('imgstepbig4-hid').id = "imgstepbig4";};
  var imgelem4H = function(){document.getElementById('imgstep4').id = "imgstep4-hid";};
  var imgN4 = function(){document.getElementById('imgstep4').style.display = "none";};*/

function IMGexpand1(){
  if(document.getElementById('imgstepbig1-hid') != null){
      document.getElementById('imgstep1').id = "imgstep1-hid";
      document.getElementById('imgstepbig1-hid').id = "imgstepbig1";
      document.getElementById('imgexB1').innerHTML = "画像を縮小";
  }else if(document.getElementById('imgstepbig1') != null){
      document.getElementById('imgstepbig1').id = "imgstepbig1-hid";
      document.getElementById('imgstep1-hid').id = "imgstep1";
      document.getElementById('imgexB1').innerHTML = "画像を拡大";
  };
};

function IMGexpand2(){
  if(document.getElementById('imgstepbig2-hid') != null){
      document.getElementById('imgstep2').id = "imgstep2-hid";
      document.getElementById('imgstepbig2-hid').id = "imgstepbig2";
      document.getElementById('imgexB2').innerHTML = "画像を縮小";
  }else if(document.getElementById('imgstepbig2') != null){
      document.getElementById('imgstepbig2').id = "imgstepbig2-hid";
      document.getElementById('imgstep2-hid').id = "imgstep2";
      document.getElementById('imgexB2').innerHTML = "画像を拡大";
  };
};

function IMGexpand3(){
  if(document.getElementById('imgstepbig3-hid') != null){
      document.getElementById('imgstep3').id = "imgstep3-hid";
      document.getElementById('imgstepbig3-hid').id = "imgstepbig3";
        document.getElementById('imgexB3').innerHTML = "画像を縮小";
  }else if(document.getElementById('imgstepbig3') != null){
      document.getElementById('imgstepbig3').id = "imgstepbig3-hid";
      document.getElementById('imgstep3-hid').id = "imgstep3";
      document.getElementById('imgexB3').innerHTML = "画像を拡大";
  };
};

function IMGexpand4(){
  if(document.getElementById('imgstepbig4-hid') != null){
      document.getElementById('imgstep4').id = "imgstep4-hid";
      document.getElementById('imgstepbig4-hid').id = "imgstepbig4";
      document.getElementById('imgexB4').innerHTML = "画像を縮小";
  }else if(document.getElementById('imgstepbig4') != null){
      document.getElementById('imgstepbig4').id = "imgstepbig4-hid";
      document.getElementById('imgstep4-hid').id = "imgstep4";
      document.getElementById('imgexB4').innerHTML = "画像を拡大";
  };
};